import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import { ContainerHeading } from "./ContainerHeading";

interface Props {
  children: ReactNode;
}

export const ToDoListContainer: FC<Props> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <Flex position="relative" rounded="lg" w="full">
      <Flex
        bg="bg-main-emphasized"
        direction="column"
        mb={20}
        overflow="hidden"
        rounded="lg"
        w="full"
        zIndex={1}
      >
        <ContainerHeading>
          <>{t("diagnosticDashboard.todo.containerHeading")}</>
        </ContainerHeading>
        <Flex direction="column" p={{ base: 4, md: 8 }} w="full">
          {children}
        </Flex>
      </Flex>
    </Flex>
  );
};
